/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductSubCategoryResponseDto
 */
export interface ProductSubCategoryResponseDto {
    /**
     * Sub-category ID
     * @type {number}
     * @memberof ProductSubCategoryResponseDto
     */
    id: number;
    /**
     * Sub-category name/code
     * @type {string}
     * @memberof ProductSubCategoryResponseDto
     */
    name: string;
    /**
     * Category ID this sub-category belongs to
     * @type {number}
     * @memberof ProductSubCategoryResponseDto
     */
    categoryId: number;
}

/**
 * Check if a given object implements the ProductSubCategoryResponseDto interface.
 */
export function instanceOfProductSubCategoryResponseDto(value: object): value is ProductSubCategoryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    return true;
}

export function ProductSubCategoryResponseDtoFromJSON(json: any): ProductSubCategoryResponseDto {
    return ProductSubCategoryResponseDtoFromJSONTyped(json, false);
}

export function ProductSubCategoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSubCategoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'categoryId': json['categoryId'],
    };
}

export function ProductSubCategoryResponseDtoToJSON(value?: ProductSubCategoryResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'categoryId': value['categoryId'],
    };
}

